module.exports = __webpack_public_path__ + "img/w3_bil_white.809de035.png";